export const HELP = 'https://mobilemonkey.com/help';
export const HELP_BETA = HELP;
export const COMMUNITY = 'https://www.facebook.com/groups/MobileMonkey';
export const FEEDBACK =
  'https://feedback.userreport.com/dc878c6f-c560-48fb-917f-044fbf12dfef/';
